import { ContextMenuDesignTokens } from '@primeng/themes/types/contextmenu';

export const CONTEXT_MENU_WARNING_ITEM_CLASS = 'c-contextmenu-item-warning';

export const baseContextMenuToken: ContextMenuDesignTokens = {
  root: {
    background: '{white}',
    borderColor: 'unset',
    color: '{gray.950}',
    borderRadius: '0.5rem',
    shadow: '0 0.25rem 1.5rem 0 #00000033',
    transitionDuration: '{transition.duration}',
  },
  list: {
    padding: '0.25rem',
    gap: '0',
  },
  item: {
    padding: '0.5rem 0.75rem',
    borderRadius: '0.25rem',
    gap: '0.75rem',
    color: '{gray.950}',
    focusColor: '{gray.950}',
    activeColor: '{gray.950}',
    focusBackground: '{neutral.500}',
    activeBackground: '{neutral.500}',
    icon: {
      color: '{primary.500}',
      focusColor: '{primary.500}',
      activeColor: '{primary.500}',
    },
  },
  submenu: {
    // consumed by the accordion rule in `css` below, not by PrimeNG — half the way to the parent
    // label (icon + item gap), enough to read as nested without eating the fixed menu width
    mobileIndent: '0.9375rem',
  },
  submenuIcon: {
    size: '0.75rem',
    color: '{primary.500}',
    focusColor: '{primary.500}',
    activeColor: '{primary.500}',
  },
  separator: {
    borderColor: '{other.gray.100}',
  },
  css: ({ dt }: { dt: (token: string, val?: string) => string }) => `
    .p-contextmenu {
      min-width: 12.5rem;
      max-width: 12.5rem;
    }

    .p-contextmenu-item-label {
      font-size: 11px;
      font-weight: 500;
      line-height: 150%;
    }

    .p-contextmenu-separator {
      margin: 0.25rem -0.25rem;
    }

    /*
     * Accordion mode (viewport under the \`breakpoint\` input): the submenu is rendered inline, under
     * its parent, so it needs an indent to read as nested. PrimeNG's own rule cannot deliver it — it
     * indents through \`--p-tieredmenu-submenu-mobile-indent\`, a variable no component in this app
     * emits (no \`p-tieredMenu\` anywhere), so the declaration is dropped and the list ends up flush
     * with its parent.
     */
    .p-contextmenu-mobile .p-contextmenu-submenu {
      padding-left: ${dt('contextmenu.submenu.mobile.indent')};
      padding-right: 0;
    }

    /* global disabledOpacity is 1, so disabled items are dimmed by color instead */
    .p-contextmenu-item.p-disabled > .p-contextmenu-item-content {
      cursor: default;
      color: ${dt('contextmenu.item.color')};
      opacity: 0.4;
    }

    .p-contextmenu-item.p-disabled > .p-contextmenu-item-content:hover {
      background: transparent;
    }

    /* a notice row: disabled so it can't be clicked or focused, but shown at full strength */
    .p-contextmenu-item.${CONTEXT_MENU_WARNING_ITEM_CLASS} > .p-contextmenu-item-content,
    .p-contextmenu-item.${CONTEXT_MENU_WARNING_ITEM_CLASS} > .p-contextmenu-item-content:hover {
      opacity: 1;
      color: var(--p-red-500);
      background: var(--p-red-50);
    }

    .p-contextmenu-item.${CONTEXT_MENU_WARNING_ITEM_CLASS} .p-contextmenu-item-icon {
      color: inherit;
    }
  `,
};
